import Enums from "../../enums";
import UserInfo from "../../UserInfo";
import { trakrefFontFamilySemiBold } from "../../utils";
import { Grey3 } from "../../color_utils";
import moment from "moment";

export const initialWorkOrderState = {
    open: true,
    type: "",
    priorityId: "",
    workOrderNumber: "",
    priorityDescription: "",
    locationId: "",
    serviceCompanyId: "",
    scheduledDate: "",
};

export const requiredFields = [
    'type',
    'workOrderNumber',
    'locationId',
    'serviceCompanyId',
    'scheduledDate',
];

export const workOrderLabelStyle = {
    flexShrink: 0,
    color: Grey3,
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: trakrefFontFamilySemiBold,
    lineHeight: 2.5
};

export const getAdditionalRequiredFields = (type) => {
    const fieldMap = {
        [Enums.WorkOrderTypes.ScheduledMaintenance]: [
            ...getRequiredFields(),
            'workScheduled',
        ],
        [Enums.WorkOrderTypes.TroubleProblemTicket]: [
            ...getRequiredFields(),
            'priorityId',
            'priorityDescription',
        ]
    };
    return fieldMap[type];
};

export const gridContainerProps = {
    container: true,
    direction: "row",
    alignItems: "center",
    sx: { maxWidth: { xs: '100%', lg: 'calc(65% + 32px)' }, marginBottom: '2%', pt: { xs: 2, lg: 0 } },
};

export const getRequiredFields = () => {
    if (!UserInfo.isWorkOrderNumberRequired()) {
        return requiredFields.filter(key => key !== "workOrderNumber");
    }

    return requiredFields;
};

export const formatDate = (date) => {
  if (!date) return "N/A";
  return moment(date).format("L");
};